'use client';

import dynamic from 'next/dynamic';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import ProductListingPagePlaceholder from 'components/consumer/ProductListingPage/ProductListingPagePlaceholder';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import WarehouseIdHydrator from '@/joystagram-components/global-state/warehouseIdForUser/WarehouseIdHydrator';

const CategoryPage = dynamic(() => import('components/consumer/CategoryPage'), {
  loading: ProductListingPagePlaceholder,
});

const StyleCategoryClient = ({
  category,
  slug,
  serverCategoryData,
  serverWarehouseId,
  algoliaUserToken,
  serverSeoResolved = true,
  algoliaAnalyticsParams,
  isAdmin,
}) => {
  if (isAdmin) {
    return (
      <AdminPlaceholder>
        ProductAndCategory Component Placeholder for Variant Builder. <br />
        The component will display the product page correctly in Consumer
      </AdminPlaceholder>
    );
  }

  const categoryPageSlug = `${category}/${slug}`;

  return (
    <WarehouseIdHydrator warehouseId={serverWarehouseId}>
      <SuspenseWithLoader
        fallback={<ProductListingPagePlaceholder />}
        key={categoryPageSlug}
      >
        <CategoryPage
          key={categoryPageSlug}
          slug={categoryPageSlug}
          serverCategoryData={serverCategoryData}
          algoliaUserToken={algoliaUserToken}
          serverSeoResolved={serverSeoResolved}
          algoliaAnalyticsParams={algoliaAnalyticsParams}
        />
      </SuspenseWithLoader>
    </WarehouseIdHydrator>
  );
};

export default StyleCategoryClient;
